import React, { useEffect, useState } from "react";
import CanvasJSReact from "../../../../../assets/canvasjs/canvasjs.react";
import { getStrokes, isIsoDate } from "../../../../../utils";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const StrokesGraph = (props) => {
  
  let queryParams = {
    startDate: props.startTime.getISOStringOfTimezone(),
    endDate: props.endTime.getISOStringOfTimezone(),
    groupBy: "machine",
    alldata: "1",
    machineId: props.machineId,
    lineId: props.lineId,
    plantId: props.plantId,
    source:'downtimePage'
  };

  let strokesUrl = getStrokes(queryParams);

  const [strokesArray, setStrokesArray] = useState([]);
  const [success,setSuccess] = useState(null);

  useEffect(async () => {
    if(props.machineId=="" || props.machineId ==undefined){
        return;
    }
    if(props.lineId=="" || props.lineId ==undefined){
      return;
    }
    if(props.plantId=="" || props.plantId ==undefined){
      return;
    }
    if(!isIsoDate(queryParams.startDate) || !isIsoDate(queryParams.endDate)){
      throw "Invalid Time Format";
      return;
    }

    setSuccess(null);
    let { data } = await axios.get(strokesUrl);
    if (data[0]) {
      setStrokesArray(data[0].rawData);
      setSuccess(true);
      // toast.info(`${props.name} Loaded`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
    }else{
      setStrokesArray([]);
      setSuccess(false);
      // toast.error(`No ${props.name} in this time range.`, {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
    }

  }, [props.strokesGraphFlag]);

  let data = [];

  let startTime = {
    y: 0,
    x: new Date(props.startTime),    
    markerType:'cross',
    markerSize: 20,
    markerColor:'black'
  }

  data.push(startTime)

  for (let index = 0; index < strokesArray.length; index++) {
    const element = strokesArray[index];
    let datapoint = {
        y: element[props.parameter],
        x:  new Date(-5.5 * 3600000 + new Date(element["time"]).getTime()),       
      }

      if(element[props.parameter]==0){
        datapoint["markerColor"] = "red";
        datapoint["markerType"] = "circle";
        datapoint["markerSize"] = 6;
      }else if(element[props.parameter]>0){
        datapoint["markerColor"] = "#34eb34";
        datapoint["markerType"] = "circle";
        datapoint["markerSize"] = 6;
      }else{
        datapoint["markerColor"] = "black";
        datapoint["markerType"] = "circle";
        datapoint["markerSize"] = 6;
        datapoint.y = 0;
      }
    data.push(datapoint);
  }

  let endTime = {
    y: 0,
    x: new Date(props.endTime),    
    markerType:'cross',
    markerSize: 20,
    markerColor:'black'
  }

  data.push(endTime);

  const options = {
    zoomEnabled: true,
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2", // "light1", "dark1", "dark2"
    title: {
      text: props.heading,
    },
    axisY: {
      title: `${props.name} Applied`,
      includeZero: true,
      suffix: "",
      maximum: props.maximum,
      minimum:0,
      lineThickness: 2
    },
    axisX: {
      title: "Time",
      prefix: "",
      //interval: 2
    },
    data: [
      {
        type: "splineArea",
        markerSize: 2,
	xValueFormatString: "hh:mm TT",      
        toolTipContent: "{x}: {y}",
        dataPoints: data,
        lineColor:"#34eb34",
        fillOpacity: .3,
        color: "#34eb34"
      },
    ],
  };

  return (
    <>
    {success==false?"Loading...":
      <CanvasJSChart
        options={options}
        /* onRef={ref => this.chart = ref} */
      />}
      {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
    </>
  );
};

StrokesGraph.defaultProps = {
  name: "Strokes",
  parameter: "numStrokes",
  maximum:20
}

